import React from 'react';
import Permiso from '../../components/permiso/Permiso';
import Layout from '../../components/layout/Layout';

const PermisoPage = () => {
    return ( <Layout children={<Permiso />} /> )
}

export default PermisoPage